import React, { useContext, useEffect, useState } from "react";
import "../Accounts/Accounts.css";
import useAuth from "../../../hooks/useAuth";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import { useLocation, useParams } from "react-router-dom";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
} from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { AccountListContext } from "../../../context/AccountListContext";
import AllClients from "./AllClients";

export default function ClientsWithIndustries() {
  useAuth();

  const currentUrl = useLocation().pathname;
  const { user } = useUser();
  // const context = useContext(AccountListContext);
  // const { loading } = context;

  const [loader, setLoader] = useState(false);

  /**
   * Redirect CLIENT roles (same behavior retained)
   */
  // if (user?.role_key === "CLIENT" || user?.role_key === "CLIENT_EMPLOYEE") {
  //   window.location.replace("/clients_accounts");
  // }

  const pageParsedData = getUrlDetailsObj(useLocation, useParams);

  /**
   * Activity tracking
   */
  useEffect(() => {
    if (user?.company_id) {
      const userStat = getUserStatsObject(
        "Companies",
        "page_load",
        "Page Source: Companies",
        currentUrl
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [user?.company_id]);

  /**
   * Loader sync
   */
  // useEffect(() => {
  //   setLoader(loading);
  // }, [loading]);

  return (
    <div className="container-fluid">
      {loader && <ScreenLoader />}

      <div className="row">
        <AllClients user={user} />
      </div>
    </div>
  );
}
